import { EventEmitter } from 'events'

export const authEvent = new EventEmitter()
